<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="small">
        <div class="content-name">
          <h2 class="dp-ib">{{ title }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 검색조건 영역 -->
      <div class="search-form">
        <el-form size="mini" label-width="80px">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="4">
              <el-form-item label="처리년도">
                <el-select v-model="form.years">
                  <el-option
                      v-for="item in combos['years']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="제품군">
                <el-select v-model="form.itemGroup">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['modelGroup']"
                      :key="item.id"
                      :value="item"
                      :label="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="form.itemDetail" v-if="form.itemGroup != '' && combos['modelDetail'].length > 0">
                  <el-option value='' label="전체">==전체==</el-option>
                  <el-option
                      v-for="item in combos['modelDetail']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="대표모델">
                <el-input type="text" v-model="form.standardModelNm" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 테이블 -->
      <div class="talbe-contain">
        <div class="table-sub-contain"  style="width: 100%;">
          <div class="table-area">
            <div class="table-b">
              <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
              <ag-grid-vue
                  ref="gridSub"
                  style="width: 100%; height: 78vh; min-height: 25px;"
                  class="ag-theme-alpine"
                  :enableRangeSelection="true"
                  :columnDefs="columnDefsSub"
                  :defaultColDef="defaultColDefSub"
                  :frameworkComponents="frameworkComponents"
                  :rowData="subData"
                  :gridOptions="gridOptionsSub"
                  :suppressRowClickSelection="false"
                  :statusBar="statusBar"
                  @grid-ready="onReadyMain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';

/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

function detailRowSpan(params) {
  // console.log('params    ',params);
  // return params.node.id === "0" ? 5 :  1;
}

export default {
  mixins: [common],
  name: "product",
  components: {},
  data() {
    return {
      title: "",
      deleteList: [],
      parentNm: "",
      form: {
        startDt: this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
        modelCd : "",
        maker : "",
        modelGroup : "",
        standardModelNm : "",
        modelNm : "",
        asAgentId: "",
        asAgentNm: "",
        areaAgent: "",
        areaAgentDetail: "",
        agerntUser: "",
        itemGroup : "",
        itemDetail: "",
        payYn : '',
        custType : '',
        years : this.$moment().format('YYYY'),
      },
      defForm: {
        groupKey: "",
        groupNm: "",
        groupUid: "",
        parentId: "",
        topKey: "",
        groupIdx: "",
        description: "",
        groupValue1: "",
        groupValue2: "",
        groupValue3: "",
        groupValue4: "",
        groupValue5: "",
      },
      data: [],
      subData: [],
      modelData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        // getRowStyle: (params) =>
        //     params.node.lastChild
        //         ? { backgroundColor: 'yellow', 'font-weight': 'bold' }
        //         : null
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      combos: {
        'modelGroup' : [],
        'modelDetail' : [],
        'years' : [],
      },
      groupDetail: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      selectId : "",
      makerCombo : [],
      productCombo1 : [],
      productCombo2 : [],
      componentForm : [],
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
      this.autoSizeAll(this.gridApi);
      // this.goOpen();
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;
      this.autoSizeAll(this.gridApiSub);
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.columnDefsSub = [
        {headerName:'제품군', field:'modelGroup', width:100, editable:false,
          valueFormatter: (params) => {
            return vm.getModelFormat(`${params.value}`);
          }
        },
        {headerName:'대표모델', field:'standardModelNm', width:100, editable:false},
        {headerName:'모델', field:'modelNm', width:100, editable:false},
        {headerName:'고장원인', field:'asFailureCauseCatNm3', width:100, editable:false},
        {
          headerName: '월별', children: [
            {headerName: '1월', field: 'qty01', width: 50, editable: false},
            {headerName: '2월', field: 'qty02', width: 50, editable: false},
            {headerName: '3월', field: 'qty03', width: 50, editable: false},
            {headerName: '4월', field: 'qty04', width: 50, editable: false},
            {headerName: '5월', field: 'qty05', width: 50, editable: false},
            {headerName: '6월', field: 'qty06', width: 50, editable: false},
            {headerName: '7월', field: 'qty07', width: 50, editable: false},
            {headerName: '8월', field: 'qty08', width: 50, editable: false},
            {headerName: '9월', field: 'qty09', width: 50, editable: false},
            {headerName: '10월', field: 'qty10', width: 50, editable: false},
            {headerName: '11월', field: 'qty11', width: 50, editable: false},
            {headerName: '12월', field: 'qty12', width: 50, editable: false},
            {headerName: '년계', field: 'totQty', width: 50, editable: false},
          ], width: 1200, editable: false,
        },
      ];

    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/reportMng/asCause/list", {
            companyId: this.$store.state.loginInfo.compCd,
            yyyy : this.form.years,
            modelGroup: this.form.itemDetail ? this.form.itemDetail : (this.form.itemGroup ? this.form.itemGroup.key : ''),
            standardModelNm : this.form.standardModelNm,
            page : 1,
            totalPage : 99999,
            totalCount : 1,
            curPage : 1,
            processTime : ""
          })
          .then(response => {
            this.subData = response.data;
            // this.(this.subData);
          }).finally(() => {
        this.autoSizeAll(this.gridApi);
        this.$store.commit('finish')
      });

    },
    updateData(data){
      data.forEach(function (d, index) {
        d.id = 'R' + (index + 1);
      });
      const dataSource = {
        rowCount: undefined,
        getRows: (params) => {

          setTimeout(function () {
            const dataAfterSortingAndFiltering = this.sortAndFilter(
                data,
                params.sortModel,
                params.filterModel
            );
            const rowsThisPage = dataAfterSortingAndFiltering.slice(
                params.startRow,
                params.endRow
            );

            let lastRow = -1;
            if (dataAfterSortingAndFiltering.length <= params.endRow) {
              lastRow = dataAfterSortingAndFiltering.length;
            }

            params.successCallback(rowsThisPage, lastRow);
          }, 500);
        },

      };
      // params.api.setDatasource(dataSource);
    },
    getModelFormat(val){
      let value = val;
      this.modelData.forEach(x=>{
        if(x.key === val) value = x.value;
      })
      return value;
    },
    sortAndFilter(allOfTheData, sortModel, filterModel){
      return this.sortData(sortModel, this.filterData(filterModel, allOfTheData));
    },
    sortData(sortModel, data) {
      const sortPresent = sortModel && sortModel.length > 0;
      if (!sortPresent) {
        return data;
      }

      const resultOfSort = data.slice();
      resultOfSort.sort(function (a, b) {
        for (let k = 0; k < sortModel.length; k++) {
          const sortColModel = sortModel[k];
          const valueA = a[sortColModel.colId];
          const valueB = b[sortColModel.colId];

          if (valueA == valueB) {
            continue;
          }
          const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
          if (valueA > valueB) {
            return sortDirection;
          } else {
            return sortDirection * -1;
          }
        }

        return 0;
      });

      return resultOfSort;
    },
    filterData(filterModel, data) {
      const filterPresent = filterModel && Object.keys(filterModel).length > 0;
      if (!filterPresent) {
        return data;
      }
      const resultOfFilter = [];
      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        if (filterModel.age) {
          const age = item.age;
          const allowedAge = parseInt(filterModel.age.filter);
          // EQUALS = 1;
          // LESS_THAN = 2;
          // GREATER_THAN = 3;
          if (filterModel.age.type == 'equals') {
            if (age !== allowedAge) {
              continue;
            }
          } else if (filterModel.age.type == 'lessThan') {
            if (age >= allowedAge) {
              continue;
            }
          } else {
            if (age <= allowedAge) {
              continue;
            }
          }
        }
        if (filterModel.year) {
          if (filterModel.year.values.indexOf(item.year.toString()) < 0) {
            // year didn't match, so skip this record
            continue;
          }
        }
        if (filterModel.country) {
          if (filterModel.country.values.indexOf(item.country) < 0) {
            continue;
          }
        }
        resultOfFilter.push(item);
      }
      return resultOfFilter;
    },

    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/reportMng/asCause/init`,{
          parentId: this.form.itemGroup.id
        })
          .then(response => {
            this.combos['modelGroup'] = response.data.modelGroup;
            this.combos['modelDetail'] = response.data.modelDetail;
            this.combos['years'] = response.data.years;
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
    },
    init2(){
      this.$store.commit('loading');
      this.$http.post(`/api/bomMng/init`)
          .then(response => {
            this.modelData = response.data.modelGroup;
          }).finally(() => {
        //this.goOpen();
        this.$store.commit('finish');
      });
    },

  },
  beforeMount() {

    this.init();
    this.init2();
    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
    this.title = this.$route.name;
  },
  watch: {
    'form.itemGroup'() {
      this.init();
    },
  }
};

</script>


<style scoped>
.gridbox {
  height: 200px !important;
}
.gridbox .objbox {
  height: 350px !important;
}

.desc-content:after {
  clear: both;
  content: "";
  display: block;
}
.btn-wrap {
  margin-bottom: 20px;
}
.desc-content {
  border: 2px solid #9db6c9;
  background: #f9fafc;
  margin: 0 0 20px 0;
  border-radius: 4px;
  padding: 15px 2%;
  clear: both;
}
.desc-content .item {
  float: left;
}
.desc-content .item .desc-item {
  position: relative;
  padding-left: 82px;
  margin-bottom: 8px;
}
.desc-content .item .desc-item:last-child {
  margin-bottom: 0;
  height: 25px;
}
.desc-content .item .desc-item .tit {
  position: absolute;
  left: 0;
}
.desc-content .item .desc-item .label-tit {
  font-family: "NotoM";
  color: #222;
  font-size: 15px;
}
.desc-content .item.desc-left .desc-item {
  padding-left: 90px;
}
.desc-content .item.desc-left .desc-item .desc:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .desc .datepicker {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc span.wave {
  float: left;
  padding: 0 6px;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area:after {
  clear: both;
  content: "";
  display: block;
}
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
.desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
  float: left;
}
.desc-content .item.desc-left .desc-item .desc.select select {
  width: 70%;
}
.desc-content .item.desc-left {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-center {
  width: 35%;
  padding-right: 40px;
}
.desc-content .item.desc-right {
  width: 30%;
}
.search-area input {
  position: relative;
}
.search-area .icon {
  position: absolute;
  right: 8px;
  top: 1px;
  z-index: 100;
  cursor: pointer;
  font-size: 16px;
  color: #555;
}
.search-border .td-s-thumb {
  position: relative;
  display: inline-block;
}
.search-border .td-s-thumb.search-area > input,
.search-border
.td-s-thumb.search-area
> .ip-box
.search-border
.td-s-thumb.search-area
> button {
  float: left;
}
.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
  width: 60%;
  margin-left: 6px;
}
.remove_text {
  margin-left: 0;
}
.contents div.gridbox_material.gridbox .xhdr {
  border-bottom: 1px solid #dfdfdf;
}

.btn-search {
  border-radius: 4px;
  padding: 0 20px;
  font-size: 15px;
  height: 34px;
  font-family: 'NotoM';
  background: #646464;
  color: #fff;
}

@media (max-width: 1580px) {
  .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 50%;
  }
}
</style>